<template>
<page-wrapper>
   <form-wrapper>
      <register-form />
      <hr/>
      <go-to-link
         question="Already have an account?"
         label="Log In"
         routeName="login"
      />
   </form-wrapper>
</page-wrapper>
</template>

<script>
import PageWrapper from '../../atoms/Login/PageWrapper';
import RegisterForm from '../../organisms/Register/RegisterForm';
import FormWrapper from '../../atoms/Login/FormWrapper';
import GoToLink from '../../molecules/Login/GotoPageLink';

export default {
  name: "Register",
  components: {
     RegisterForm,
     PageWrapper,
     FormWrapper,
     GoToLink,
  }
};
</script>
